import {Utils} from "../Modules/Utils";

Utils.executeWhenDocumentIsReady(() => {

    const container:HTMLElement = document.querySelector('[data-banner]');
    const closeIcon:HTMLElement = document.querySelector('[data-banner-close]');

    if (!container || !closeIcon) {
        return;
    }

    const bannerTreeId = container.dataset.bannerTreeId;
    
    // Prüfe beim Laden, ob der Banner bereits geschlossen wurde
    if (bannerTreeId && sessionStorage.getItem(bannerTreeId) !== 'closed') {
        container.classList.add('visible');
    }

    // Event Listener für das Schließen des Banners
    closeIcon.addEventListener('click', () => {
        if (bannerTreeId) {
            sessionStorage.setItem(bannerTreeId, 'closed');
            container.classList.remove('visible');
        }
    });
});